import { useHead } from '@unhead/react';
import { useEffect, useState } from 'react';

export function CarregandoSistema() {
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    useEffect(() => {
        const favicon = document.getElementById('favicon') as HTMLLinkElement;

        if (favicon) {
            favicon.href = 'data:image/x-icon;';
        }

        // Timer para exibir mensagem de erro após 5 segundos
        const timer = setTimeout(() => {
            setShowErrorMessage(true);
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    useHead({ title: 'Carregando...' });

    return (
        <div className='flex h-screen w-screen flex-col items-center justify-center gap-2'>
            <img
                alt='Carregando'
                src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDFweCIgIGhlaWdodD0iNDFweCIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIiBjbGFzcz0ibGRzLXJvbGxpbmciPiAgICA8Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiBmaWxsPSJub25lIiBuZy1hdHRyLXN0cm9rZT0ie3tjb25maWcuY29sb3J9fSIgbmctYXR0ci1zdHJva2Utd2lkdGg9Int7Y29uZmlnLndpZHRofX0iIG5nLWF0dHItcj0ie3tjb25maWcucmFkaXVzfX0iIG5nLWF0dHItc3Ryb2tlLWRhc2hhcnJheT0ie3tjb25maWcuZGFzaGFycmF5fX0iIHN0cm9rZT0iIzAxOTBmZSIgc3Ryb2tlLXdpZHRoPSIxMCIgcj0iMzUiIHN0cm9rZS1kYXNoYXJyYXk9IjE2NC45MzM2MTQzMTM0NjQxNSA1Ni45Nzc4NzE0Mzc4MjEzOCIgdHJhbnNmb3JtPSJyb3RhdGUoODQgNTAgNTApIj4gICAgICA8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJ0cmFuc2Zvcm0iIHR5cGU9InJvdGF0ZSIgY2FsY01vZGU9ImxpbmVhciIgdmFsdWVzPSIwIDUwIDUwOzM2MCA1MCA1MCIga2V5VGltZXM9IjA7MSIgZHVyPSIxcyIgYmVnaW49IjBzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSI+PC9hbmltYXRlVHJhbnNmb3JtPiAgICA8L2NpcmNsZT4gIDwvc3ZnPg=='
            />

            <div className='text-2xl font-bold'>Carregando sistema...</div>

            {showErrorMessage && (
                <div className='mt-4 text-center text-xl text-red-500'>
                    <p>Isso está demorando mais que o normal.</p>
                    <p>Verifique sua conexão com a internet ou entre em contato com o suporte.</p>
                </div>
            )}
        </div>
    );
}
